/**
 * This regex matches the backend regex:
 * https://github.com/Frameio/massdriver/blob/facf6ed93de7904b7f5e6b54ed70ab332c6465ed/apps/core/lib/core/accounts/user.ex#L959
 */
export const EMAIL_REGEX = /^[^@.\s]+[^@\s]*@([a-z0-9-]+\.){1,}[a-z0-9-]+$/i;

export const isValidEmail = (maybeEmail: string) =>
  EMAIL_REGEX.test(maybeEmail);
